import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {PagesRoutingModule} from './pages-routing.module';
import {PageComponent} from './pages.component';
import {SIDEBAR_TOGGLE_DIRECTIVES} from '../shared/sidebar.directive';
import {NAV_DROPDOWN_DIRECTIVES} from '../shared/nav-dropdown.directive';
import {NavigationComponent} from '../shared/header-navigation/navigation.component';
import {SidebarComponent} from '../shared/sidebar/sidebar.component';
import {RightSidebarComponent} from '../shared/right-sidebar/rightsidebar.component';
import {BreadcrumbComponent} from '../shared/breadcrumb/breadcrumb.component';
import {FormsModule} from '@angular/forms';
import {UserService} from './user.service';

@NgModule({
  imports: [
    CommonModule,
    PagesRoutingModule,
    FormsModule,
  ],
  declarations: [
    PageComponent,
    NavigationComponent,
    BreadcrumbComponent,
    SidebarComponent,
    RightSidebarComponent,
    SIDEBAR_TOGGLE_DIRECTIVES,
    NAV_DROPDOWN_DIRECTIVES,
  ],
  providers: [UserService]
})
export class PagesModule {
}



// WEBPACK FOOTER //
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/app/pages/pages.module.ts